import * as React from 'react';
import XSifterQueryBuilder from './search/XSifterQueryBuilder';
import { IXSifterSavedQuery } from '../types/XSifterQueries';
import { useState } from 'react';
import { useSearchParams } from 'react-router';
import XSifterQueryService from '../services/XSifterQueryService';
import { IXSifterUser } from '../types/XSifterAppUser';
import { useAppSelector } from '../store/hooks';

interface IXSifterAppQueryProps {
    currentUser: IXSifterUser | undefined,
    onForceHeaderRemount: ()=>void
}

const XSifterQuery: React.FC<IXSifterAppQueryProps> = (props: IXSifterAppQueryProps) => {
    const [savedQuery, setSavedQuery] = useState<IXSifterSavedQuery | null>(null);
    const [queryParams] = useSearchParams();
    const savedQueryId = queryParams.get("queryId");
    const duplicateQuery = queryParams.get("duplicate");
    const queryService = new XSifterQueryService();

    React.useEffect(() => {
        if (!savedQueryId)
            return;
        queryService.getSavedQuery(savedQueryId)
            .then((response) => {
                setSavedQuery(response);
            }).catch((error) => {
                setSavedQuery(null);
            })
    }, []);

    let queryIdToUse = savedQueryId && !duplicateQuery ? savedQueryId : null;
    let titleToUse = (savedQueryId && !duplicateQuery && savedQuery) ? savedQuery.title ?? "" : "";

    return (
        <>
            <XSifterQueryBuilder 
                allowEdits={true} 
                currentUser={props.currentUser} 
                queryTitle={titleToUse} 
                savedQuery={savedQuery} 
                savedQueryId={queryIdToUse} 
                onForceHeaderRemount={props.onForceHeaderRemount} 
                duplicateQuery={duplicateQuery === "true"}
            />
        </>
    );
}

export default XSifterQuery;